import React, { useState } from "react";
import styles from "./index.module.scss";
import _get from "lodash/get";
import BasicForm2 from "../../components/BasicForm2";
import BasicForm from "../../components/basicForm";
import BasicForm3 from "../../components/BasicForm3";

//import SucessModal from "../dynamicSuccessModal";
import Loader from "../Loader";
import axios from "axios";
import endpoints from "../../utility/endpoints.js";
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

function index(props) {
  let mobileProps = props.mobileAddUser;

  let initialState = {
    name: "",
    image: "",
    email: "",
    userType: "",
  };
  const [loader, setloader] = useState(false);
  const [finalState, setfinalState] = useState({});
  const recievedFormValues = async (formState) => {
    //console.log("Received form values ---------", formState);
    const finalState = { ...props.createUserState, ...formState, userType };
    //console.log("final State ----", finalState);
    if (!props.editUser) {
      props.addUser(finalState);
    } else if (props.editUser) {
      editUser(finalState);
    }
    setGetFormValues(false);
  };
  const editUser = async (finalEditedState) => {
    //console.log("Final state --", finalEditedState);
    let toSend = "";
    if (
      finalEditedState.userType == "firstGfcf" ||
      finalEditedState.userType == "gfcf" || finalEditedState.userType == "businessUserRegionWise"
    ) {
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
          mco: finalEditedState.mco,
	  leadPlatform:finalEditedState.leadPlatform,
          area:finalEditedState.area,
          subArea:finalEditedState.subArea,
          cluster: finalEditedState.cluster,
        },
      };
    } else if (
      finalEditedState.userType == "firstLevelGPMApprover" ||
      finalEditedState.userType == "GPMapprover"
    ) {
      //console.log("final state --", finalEditedState);
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
          leadPlatform: finalEditedState.leadPlatform,
          area: finalEditedState.area,
          subArea: finalEditedState.subArea,
        },
      };
    } else {
      toSend = {
        email: finalEditedState.email,
        toUpdateUser: {
          userType: finalEditedState.userType,
        },
      };
    }
    //console.log(toSend, "final state to send");
    // debugger;
    let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

    let expiryStatus = await props.checkExpiry(authCheck);
    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      updateUser(auth, toSend);
    } else {
     
      setLoader(false);
      props.sessionTimeOutCheck(true);
    }
  };

  const updateUser = async (auth, toSend) => {
    try {
      setloader(true);
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        
     
      const resp = await axios({
        method: "PUT",
        url: `${endpoints.baseUrl}/user/updateUserDetails`,
        data: toSend,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      });
      //console.log("respose all user ", resp.data);
      if (resp.data.code == 403) {
        setloader(false);
        props.sessionTimeOutCheck(true);
      } else if (resp.data.code == 401 || resp.data.code == 402) {
        setloader(false);
        props.setmobileSucess(true);
        props.getUserData();
        props.setEditUser(false);
      } else if (resp.data.code == 200) {
        setloader(false);
        props.setmobileSucess(true);
        props.userEdited();
        props.setEditUser(false);
        //console.log("response udapte user  ---", resp.data);
      }
    }
    else {
      props.sessionTimeOutCheck(true)
      setLoader(false)
      
    }
    } catch (e) {
      console.log("eroor", e);
    }
  };
  const [sucess, setsucess] = React.useState(false);

  const [invalidFlag, setInvalidFlag] = React.useState(false);
  const [userType, setUserType] = React.useState("");
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [userToBeEdited, setUserToBeEdited] = React.useState({});
  const [invalidUsertypeFlag, setInvalidUserType ] = React.useState(false)
  // const [props.createUserState, setCreateUserState] = React.useState(initialState);
  React.useEffect(() => {
    if (props.editUser) {
      //console.log("User to be edited", props.userToBeEdited);
      setUserToBeEdited(props.userToBeEdited);
      setUserType(props.userToBeEdited.userType);
    }
  }, []);

  const message = {
    field_title: "User created",
  };
  const radioInputChange = (e) => {
    // console.log(e.target.name, "name of state to chanfge ", "e target value ---", e.target.value);
    setUserType(e.target.value);
  };
  React.useEffect(() => {
    setInvalidFlag(props.mobileError);
  }, [props.mobileError]);

  React.useEffect(() => {
   setInvalidUserType(props.invalidUsertypeMobileError)
  }, [props.invalidUsertypeMobileError])

  

  React.useEffect(() => {
    setsucess(props.mobileSucess);
  }, [props.mobileSucess]);

  const addEditUser = async () => {
    //console.log("Add or edit user ---");
    if (
      userType == "firstGfcf" ||
      userType == "gfcf" ||
      userType == "firstLevelGPMApprover" ||
      userType == "GPMapprover"
      || userType == "businessUserRegionWise"
      || userType == "landscape"
      || userType == "infosec"

    ) {
      setGetFormValues(true);
    } else if (!props.editUser) {
      //console.log(props.createUserState, "props.createUserState", userType)
      props.addUser({ ...props.createUserState, userType: userType });
    } else if (props.editUser) {
      let editUserState = userToBeEdited;
      //console.log("user to be edited ---", editUserState);
      editUserState.userType = userType;
      editUser(editUserState);
    }
    // else if (props.editUser) {

    // }
  };

  return (
    <div className={styles.editModalWrapper}>
      <div className={styles.modalBox}>
        <div className={styles.modalHeader}>
          <p className={styles.content}>
            {props.editUser ? "Edit User" : "Add User"}
          </p>
        </div>
        <div className={styles.modalBody}>
          {props.editUser == false ? (
            <div className={styles.formGroup}>
              <label>
                Email<sup>*</sup>
              </label>
              <input
                className={`${invalidFlag ? styles.errorBorder : null}`}
                type="text"
                placeholder="Email"
                name="email"
                onChange={props.inputChange}
                value={props.createUserState.email}
              />
              {invalidFlag ? (
                <span className={styles.errorMessage}>
                  Email can't be Empty / Enter valid unilever email
                </span>
              ) : null}

              { 
              <div  className={styles.userTypeerrorMessage}>
              { invalidUsertypeFlag ? <span className={styles.errorMessage}>
              Please select usertype
            </span> : null }
            </div>
            }


            </div>
          ) : null}
          <div className={styles.formGroup}>
            <label className={styles.mainLabel}>
              {_get(
                mobileProps,
                "data.field_component[1].component.content.field_label",
                ""
              )}
            </label>
            <div
              className={styles.inputGroupWrapper}
              onChange={radioInputChange}
            >
              {_get(
                mobileProps,
                "data.field_component[0].component.content.field_user_mapping_fields[1].field_input_values",
                []
              ).map((item, index) => (
                <label className={styles.radioWrapper} key={index}>
                  <span className={styles.subLabel}>
                    {_get(item, "field_input_value_1", "")}
                  </span>
                  <input
                    type="radio"
                    className={styles.radioBox}
                    value={_get(item, "field_input_value_2", "")}
                    name="couldBeAnything"
                    checked = {_get(item, "field_input_value_2", "") == userType}


                    // checked={userType == "editAccess"}
                  />
                  <span className={styles.radioCheckmark}></span>
                </label>
              ))}

              {userType == "firstGfcf" || userType == "gfcf" || userType ==  "businessUserRegionWise" ? (
                <BasicForm2
                  data={[...props.formData1,...props.formData2] }
                  notRequired={['Area','Sub Area','MCO','Lead Platform']}
                  sendFormValues={recievedFormValues}
                  getFormValues={getFormValues}
                  emptyFormValues={emptyFormValues}
                  formType="userCreateData"
                  //editState={state}
                  demandEditData={userToBeEdited}
                  setGetFormValues={setGetFormValues}
                  type="user"
                />
              ) : null}

              {userType == "firstLevelGPMApprover" ||
              userType == "GPMapprover" ? (
                <BasicForm2
                  data={props.formData2}
                  notRequired={['Area','Sub Area','MCO']}
                  sendFormValues={recievedFormValues}
                  getFormValues={getFormValues}
                  emptyFormValues={emptyFormValues}
                  formType="userCreateData"
                  // editState={state}
                  demandEditData={userToBeEdited}
                  type="user"
                  setGetFormValues={setGetFormValues}
                />
              ) : null}
               {userType == "landscape"? (
                <BasicForm3
                  data={props.formData3}
                  sendFormValues={recievedFormValues}
		notRequired={[]}
                  getFormValues={getFormValues}
                  emptyFormValues={emptyFormValues}
                  formType="userCreateData"
                  // editState={state}
                  demandEditData={userToBeEdited}
                  type="user"
                  setGetFormValues={setGetFormValues}
                />
              ) : null}
               
            </div>
          </div>
        </div>
        
      
        <div className={styles.modalFooter}>
          <div className={styles.combinedBtn}>
            <span
              className={styles.rowBtn}
              onClick={
                props.editUser
                  ? () => {
                      props.setEditUser(false);
                    }
                  : () => props.setMobileAddUserForm(false)
              }
            >
              Cancel
            </span>
            <span className={styles.exportListBtn} onClick={addEditUser}>
              {props.editUser ? "Edit User" : "Add User"}
            </span>
          </div>
        </div>
        {loader ? <Loader /> : null}
      </div>
      {/* {sucess ? (
        <SucessModal data={message} setSuccessModal={setsucess} />
      ) : null} */}
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

